import { render, staticRenderFns } from "./OrderSetting.vue?vue&type=template&id=6bd99c09&scoped=true"
import script from "./OrderSetting.vue?vue&type=script&lang=js"
export * from "./OrderSetting.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bd99c09",
  null
  
)

export default component.exports